<template>
  <div class="d-flex align-items-center">
    <div class="px-2">
      <span v-if="agente"><b>Agente: </b>Juan López Pérez</span>
    </div>
    <CDropdown
      inNav
      class="c-header-nav-items"
      placement="bottom-end"
      add-menu-classes="pt-0"
    >
      <template #toggler>
        <CHeaderNavLink>
          <div class="c-avatar account__icon">
            <img :src="userIcon" class="c-avatar-img" />
          </div>
        </CHeaderNavLink>
      </template>
      <CDropdownHeader tag="div" class="text-center" color="light">
        <strong>Cuenta</strong>
      </CDropdownHeader>
      <CDropdownItem @click="logOut">
        <CIcon name="cil-lock-locked" />
        <CButton>Salir</CButton>
      </CDropdownItem>
    </CDropdown>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import userIcon from "../assets/icons/usuario.svg";

export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 42,
      userIcon,
    };
  },
  methods: {
    ...mapActions(["logOut"]),
  },
  computed: {
    agente() {
      return localStorage.getItem("agentName")
    }
  }
};
</script>

<style scoped lang="scss">
.c-icon {
  margin-right: 0.3rem;
}
.account__icon {
  color: gray;
  width: 30px !important;
  padding: 5px;

  img {
    width: 100%;
    max-height: 100%;
  }
}
</style>